import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/forgot-password/loading';

export const Route = createFileRoute('/_public/forgot-password/')({
  pendingComponent: Loading,
});
